export function getFileFormat(fileName: string): string | undefined {
  return fileName.split('.').at(-1);
}

export const IMAGE_PNG_JPG_ACCEPT = '.png,.jpg,.jpeg,image/png,image/jpeg';

export function isFileAccepted(file: File, accept?: string): boolean {
  if (!accept || accept.trim() === '') return true;

  const tokens = accept
    .split(',')
    .map(t => t.trim().toLowerCase())
    .filter(Boolean);

  const fileName = file.name.toLowerCase();
  const mime = (file.type || '').toLowerCase();

  for (const token of tokens) {
    if (token === '*/*') return true;

    if (token.endsWith('/*')) {
      // e.g. "image/*" -> "image/"
      const prefix = token.slice(0, -1);
      if (mime.startsWith(prefix)) return true;
      continue;
    }

    if (token.startsWith('.')) {
      // Extension match
      if (fileName.endsWith(token)) return true;
      continue;
    }

    // Exact MIME
    if (mime === token) return true;
  }

  return false;
}

// How long the object URL outlives the click. Revoking it straight away can cut
// the download short in some browsers, which read the blob after `click()` returns.
const REVOKE_OBJECT_URL_DELAY_MS = 15000;

/** Saves `blob` to the user's machine as `filename`. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url), REVOKE_OBJECT_URL_DELAY_MS);
}
